import { UserRole } from '../core/models/user';

/** Longest comment body the API accepts. Mirrors CommentConstraints.BodyMaximumLength. */
export const COMMENT_BODY_MAX_LENGTH = 1000;

/** A comment on a test case (TestHub API TestCaseCommentDto, PBI 57768). */
export interface TestCaseComment {
  testCaseCommentId: number;
  testCaseId: number;
  /** Author. */
  userId: number;
  /** Author's display name, "First Last". */
  userName: string;
  userRole: UserRole;
  /** Plain text. Interpolate it; never bind it as HTML or feed it to <markdown>. */
  body: string;
  isDeleted: boolean;
  createdOnUtc: string;
  /** Null until the comment is first edited. */
  modifiedOnUtc: string | null;
}

export interface TestCaseCommentInsertRequest {
  userId: number;
  body: string;
}
